import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { mediaMinTablet } from '@root/shared/ui-kit'
import { Slider, SliderCarousel } from '@root/shared/ui-kit/slider'

import SLIDE_BANNER from '../assets/slide-banner.inline.svg?raw'
import SLIDE_COLOR from '../assets/slide-color.inline.svg?raw'
import SLIDE_LOGO from '../assets/slide-logo.inline.svg?raw'
import SLIDE_RAID from '../assets/slide-raid.inline.svg?raw'
import SLIDE_SPLASH from '../assets/slide-splash.inline.svg?raw'

import { PremiumSliderImage } from './premium-slider-image'

import type { ClassNameProps } from '@root/shared/lib/react'

type PremiumSliderProps = {
  mode: 'single' | 'carousel'
  slideSize?: number
} & ClassNameProps

export const PremiumSlider: React.FC<PremiumSliderProps> = ({
  className,
  mode = 'single',
  slideSize,
}) => {
  const { t } = useTranslation()

  const Cmp = mode === 'single' ? Slider : SliderCarousel

  return (
    <Cmp slideSize={slideSize} className={className}>
      <Slide>
        <SubTitle>{t('premium.slider.slide-color')}</SubTitle>
        <PremiumSliderImage svg={SLIDE_COLOR} />
      </Slide>
      <Slide>
        <SubTitle>{t('premium.slider.slide-logo')}</SubTitle>
        <SlideImageOffset svg={SLIDE_LOGO} />
      </Slide>
      <Slide>
        <SubTitle>{t('premium.slider.slide-banner')}</SubTitle>
        <PremiumSliderImage svg={SLIDE_BANNER} />
      </Slide>
      <Slide>
        <SubTitle>{t('premium.slider.slide-splash')}</SubTitle>
        <PremiumSliderImage svg={SLIDE_SPLASH} />
      </Slide>
      <Slide>
        <SubTitle>
          <Trans
            i18nKey="premium.slider.slide-raid"
            components={[<strong key={0} />, <br key={1} />]}
          />
        </SubTitle>
        <PremiumSliderImage svg={SLIDE_RAID} />
      </Slide>
    </Cmp>
  )
}

const SubTitle = styled(Typography).attrs({
  variant: 'body4-regular',
  component: 'div',
})`
  color: var(--slider-title-color, var(--text-8));
  font-weight: var(
    --slider-title-weight,
    var(--typography-body-4-regular-font-weight)
  );
  text-align: center;
  width: 300px;
  margin: 0 auto;

  ${mediaMinTablet(css`
    font-size: var(--typography-body-2-regular-font-size);
    line-height: var(--typography-body-2-regular-line-height);
  `)}
`

const Slide = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;

  align-items: center;
  justify-content: center;
`

const SlideImageOffset = styled(PremiumSliderImage)`
  margin-inline-start: 37px;
`
